/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import { Link } from 'react-router-dom';
import { useSelectedProject } from '../hooks/useSelectedProject';
import BucketPricingSection from '../components/drive/BucketPricingSection';

export default function Pricing() {
  const { selectedProjectId } = useSelectedProject();
  return (
    <div className="max-w-5xl mx-auto px-4 py-6 space-y-4">
      <div>
        <h1 className="text-2xl font-semibold text-white">Object Storage Pricing</h1>
        <p className="text-sm text-gray-400 mt-1">
          Zero egress fees, transparent metered billing, USD-pegged rates billed monthly in INR
          (GST applied at billing time).
        </p>
      </div>
      <BucketPricingSection projectId={selectedProjectId ?? ''} />

      {/* Contact Sales callout */}
      <div className="rounded-xl border border-gray-700 bg-gray-800/40 p-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex-1">
          <p className="text-sm font-medium text-white">Need committed capacity or custom pricing?</p>
          <p className="text-xs text-gray-400 mt-1">
            Talk to our sales team about volume discounts, annual commitments and enterprise terms.
          </p>
        </div>
        <Link
          to="/contact-us"
          className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors shrink-0"
        >
          Contact Sales
        </Link>
      </div>
    </div>
  );
}
